import React from 'react';
import styled from 'styled-components';
import { getPlugSDK } from '../../hooks/usePlugSDK';
import { themeColor } from '@hud/web-components/theme/colors';

const StyledLink = styled.span`
  color: inherit;
  cursor: pointer;
  text-decoration: none;
  color: ${themeColor('turquoise')};

  &:hover {
    text-decoration: underline;
  }
`;

interface ContactUsLinkProps {
  children: React.ReactNode;
  startConversationContent: string;
}

export const ContactUsLink: React.FC<ContactUsLinkProps> = ({
  children,
  startConversationContent,
}) => (
  <StyledLink
    onClick={() => getPlugSDK()?.toggleWidget?.(true, 'create_conversation', { startConversationContent })}
  >
    {children}
  </StyledLink>
);
